import { render, staticRenderFns } from "./FormOptionRequirementsModalList.vue?vue&type=template&id=2b2809c2&scoped=true&"
import script from "./form-option-requirements-modal-list.js?vue&type=script&lang=js&"
export * from "./form-option-requirements-modal-list.js?vue&type=script&lang=js&"
import style0 from "./form-option-requirements-modal-list.scss?vue&type=style&index=0&id=2b2809c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2809c2",
  null
  
)

export default component.exports